import styled from "styled-components";
import { Link as LinkRR } from "react-router-dom";
import { SideBarButtonType } from "./SideBarButtons.type";

const LinkDisable = styled.div.attrs({
  className: "flex items-center rounded-lg p-4 my-4",
})``;

const Link = styled(LinkRR).attrs<SideBarButtonType>((props) => ({
  className: props.selected
    ? "flex items-center rounded-lg bg-lav-black-Boxselect cursor-pointer"
    : "flex items-center rounded-lg hover:bg-lav-black-Boxselect cursor-pointer",
})) <SideBarButtonType>``;

const Text = styled.p.attrs({
  className: "text-lav-black-text text-base",
})``;

const TextDisable = styled.p.attrs({
  className: "text-lav-black-textdisable text-base",
})``;

export default {
  Link,
  LinkDisable,
  Text,
  TextDisable,
};
